import { Observable, of } from 'rxjs';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { CheckboxGridHeaderCell, CheckboxGridRow } from './checkbox-grid.model';
import { CheckboxGridService } from './checkbox-grid.service';

@Component({
  selector: 'checkbox-grid',
  templateUrl: './checkbox-grid.component.html',
  styleUrls: ['./checkbox-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxGridComponent implements OnChanges {
  @Input() gridTitle: string;

  /**
   * an array of strings used as column header names
   */
  @Input() headerCells: CheckboxGridHeaderCell[];

  /**
   * An array of row details with label and description
   */
  @Input() rows: CheckboxGridRow[];

  /**
   * boolean to hide or show checkbox for bulk toggling. False by default
   */
  @Input() isBulkSupported: boolean;

  @Input() isReadOnly: boolean;

  @Output() rowsUpdated: EventEmitter<CheckboxGridRow[]> = new EventEmitter<
    CheckboxGridRow[]
  >();

  public rowsStream$: Observable<CheckboxGridRow[]>;
  ownRows;

  constructor(private checkboxGridService: CheckboxGridService) {}

  ngOnChanges(sc: SimpleChanges) {
    this.ownRows = this.rows;
  }

  onRowUpdated(event) {
    this.rows.map((row) => {
      if (row.prop === event.prop) {
        row.items = event.items;
      }
    });
    this.rowsStream$ = of(this.rows);
    this.rowsUpdated.emit(this.rows);
  }

  onBulkUpdate(event) {
    this.rows.forEach((row) => {
      row.items.map((item) => {
        if (item.type === event.prop) {
          item.value = event.bulkChecked;
        }
      });
    });
    this.rowsStream$ = of(this.rows);
    this.rowsUpdated.emit(this.rows);
  }
}
